import browserUpdate from 'browser-update/update.npm';
import supportedBrowsers from './supportedBrowsers';

if (!supportedBrowsers.test(navigator.userAgent)) {
  browserUpdate({
    required: {
      s: -2,
      f: -2,
      c: -2,
      e: -2,
      o: -2,
      i: 12,
    },
    text: {
      msg: 'You are using an outdated browser ({brow_name}) that is not compatible with our site.',
      msgmore: 'For the best experience, please update your browser',
      bupdate: 'Update',
    },
    noclose: true,
    newwindow: false,
    reminder: 0,
  });
}
